import {Component, OnInit, Input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {File} from 'app/models/file';
import {FilesService} from 'app/services/files.service';
import {SortFile} from 'app/models/sort-file.enum';
import {SortDirection} from 'app/models/sort-direction.enum';
import {AssetSortingType} from 'app/models/asset-sorting-type';
import {FileView} from 'app/models/file-view.enum';
import {CompetitionService} from 'app/services/competition.service';
import {FileType} from 'app/models/file-type.enum';
import {Source} from 'app/models/source.enum';
import {ColumnSortComponent} from 'app/shared/components/column-sort/column-sort.component';

import {Document} from 'app/models/document';
import {SearchService} from 'app/services/search.service';
import {AssetsFactory} from 'app/services/assets.factory.services'
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';
@Component({
    selector: 'app-files-list',
    templateUrl: './files-list.component.html',
    styleUrls: ['./files-list.component.scss'],
    providers: [FilesService, SearchService, AssetsFactory]
})
export class FilesListComponent extends ColumnSortComponent implements OnInit {
    @Input() showDelete: boolean;
    fileView: FileView;
    sortingType: AssetSortingType;
    lastEvaluatedKey: any;
    ViewType = FileView;
    firstSort: Boolean;


    constructor(
        private filesService: FilesService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private competitionService: CompetitionService,
        private gtmService: GoogleTagManagerService,
        private assetService: AssetsFactory) {
        super(assetService);
        this.firstSort = true;
    }

    ngOnInit() {
        this.assetType = Source.Image;
        this.activatedRoute.queryParams
            .filter(params => params.view)
            .subscribe(params => {
                this.fileView = params.view;
                this.getAll();
            });
    }

    onChangeView(fileView: FileView) {
        this.router.navigate(['.'], {relativeTo: this.activatedRoute, queryParams: {view: fileView}});
    }

    onTileSort(sortingType): void {
        this.sortingType = sortingType;
        if (!this.firstSort) {
          this.gtmService.pushEvent(`Sort by - ${sortingType.name}`);
        }
        this.firstSort = false;
        this.getAll();
    }

    goTo(item) {
        this.router.navigate([item.source, item.documentId],
            {relativeTo: this.activatedRoute});
    }

    attachDocument($event) {
        const item: Document = $event.dragData,
            file = new File(null, this.competitionService.getCompetitionId(), item.name,
                item.displayName, item.contentType, item.createdTime, new Date().getTime(),
                this.getSource(item.contentType), item.id, item.documentId);

        this.filesService.create(file)
            .subscribe(res => {
                this.assets.unshift(res);
            });
    }

    onDelete(file: File): void {
        this.filesService.delete(file.id)
            .subscribe(res => this.getAll());
    }

    getNext() {
        this.getAll(this.lastEvaluatedKey);
    }

    getAll(lastEvaluatedKey?: string): void {
        this.filesService
            .getAll(lastEvaluatedKey)
            .subscribe(data => {
                this.assets = this.assets && lastEvaluatedKey ?
                    this.assets.concat(data.Items) : data.Items;
                this.lastEvaluatedKey = data.LastEvaluatedKey;
            });
    }

    private getSource(contentType: FileType): Source {
        switch (contentType) {
            case FileType.Img:
                return Source.Image;
            case FileType.Video:
                return Source.Video;
            default:
                return Source.PDF;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/files-list/files-list.component.ts